import SBEditable from "../../../components/sbEditable/sbEditable"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"
import styles from "./iframeembed.module.scss"

function IframeEmbed({ blok }) {
 return (
  <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
    <div className={`div-align-${blok.alignment || "left"} ${styles.iframeembed}`} style={{maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520}}>
      <div dangerouslySetInnerHTML={{__html: blok.iframe}} />
    </div>
  </SBEditable>
 )
}

export default IframeEmbed